import React, { useContext } from "react";
import { IoArrowBack } from "react-icons/io5";
import SummaryTable from "../Farmer/SummaryTable";
import FarmerTable from "../Farmer/FarmerTable";
import UsersContext from "../Context/UsersContext";

function VANOview({ id, setOpen }) {
  const { users, farmers } = useContext(UsersContext);
  const userdetails = users?.filter((dt) => dt?.id === id);
  const RegFarmers = farmers?.filter((dt) => dt?.creator_id === id);

  return (
    <div className="p-1 bg-gray-50">
      <>
        {/* Fourth section */}
        <div
          onClick={() => setOpen(false)}
          className="mb-2 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1"
        >
          <IoArrowBack className="text-2xl" />
          <h1 className="text-xs md:text-sm">Back</h1>
        </div>
        {/* Vano Summary Table */}
        <div className="mt-10 mb-10">
          <SummaryTable userdetails={userdetails} RegFarmers={RegFarmers} />
        </div>
        {/* VAno Farmers Enrollment List */}
        <div className="mt-10 mb-10">
          <FarmerTable users={RegFarmers} />
        </div>
      </>
    </div>
  );
}

export default VANOview;
